"use client";
import { DrupalNode } from "next-drupal";
import React from "react";
import { motion } from "framer-motion";
import Banner from "@/components/sections/Banner";

interface privacyPolicyProps {
  pageData: DrupalNode;
}

const PrivacyPolicyScreen: React.FC<privacyPolicyProps> = ({ pageData }) => {
  const { title = "", field_privacy_policy_content = {} } = pageData;
  return (
    <div className="pt-20">
      <Banner
        title={title}
        isRounded
        backgroundImg="/static/images/privacy-policy.svg"
      />
      <div className="py-12 bg-mapGray relative overflow-hidden">
        <div className="mini-container relative z-[2]">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{
              duration: 0,
            }}
            className="remove-animation-fluctuation terms-page-text text-base text-[#003350] --font-poppins leading-normal mb-5 !text-left mobileMax:text-xsmall mobileMax:leading-normal"
            dangerouslySetInnerHTML={{
              __html: field_privacy_policy_content?.value,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyScreen;
